const initialState = {
	playerReady: false,
	duration: 0,
	currentPosition: '',
	currentVolumeLevel: 0,
	showBackgroundElements: true,
	currentInteractiveElement: null,
	currentSceneWidgets: null,
	showLiveProduct: false,
	analyticsSent: false,
	showShoppingCart: false,
	showChatWindow: false,
	reactionId: '',
	isPlaying: undefined,
	polls: [],
	mediaDurations: [],
	isPosterRemoved: false,
	isLiveStarted: false,
	isLiveStopped: null,
	qnas: [],
	questions: [],
	adsPlaying: false,
};

const playerReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_PLAYER_READY':
			return {
				...state,
				playerReady: action.playerReady,
			};
		case 'SET_IS_PLAYING':
			return {
				...state,
				isPlaying: action.isPlaying,
			};
		case 'SET_SHOW_SHOPPING_CART':
			return {
				...state,
				showShoppingCart: action.showShoppingCart,
			};
		case 'SET_REACTION_ID':
			return {
				...state,
				reactionId: action.reactionId,
			};
		case 'SET_SHOW_CHAT_WINDOW':
			return {
				...state,
				showChatWindow: action.showChatWindow,
			};
		case 'SET_PLAYER_CURRENT_POSITION':
			return {
				...state,
				currentPosition: action.currentPosition,
			};
		case 'SET_PLAYER_DURATION':
			return {
				...state,
				duration: action.duration,
			};
		case 'SET_MEDIA_WITH_DURATION':
			return {
				...state,
				mediaDurations: action.mediaDurations,
			};
		case 'SET_CURRENT_VOLUME_LEVEL':
			return {
				...state,
				currentVolumeLevel: action.currentVolumeLevel,
			};
		case 'SET_SHOW_BACKGROUND_ELEMENTS':
			return {
				...state,
				showBackgroundElements: action.showBackgroundElements,
			};
		case 'SET_CURRENT_INTERACTIVE_ELEMENT':
			return {
				...state,
				currentInteractiveElement: action.currentInteractiveElement,
			};
		case 'SET_CURRENT_SCENE_WIDGETS':
			return {
				...state,
				currentSceneWidgets: action.currentSceneWidgets,
			};
		case 'SET_SHOW_LIVE_PRODUCT':
			return {
				...state,
				showLiveProduct: action.showLiveProduct,
			};
		case 'SET_ANALYTICS_SENT':
			return {
				...state,
				analyticsSent: action.analyticsSent,
			};
		case 'SET_POLL_DATA':
			return {
				...state,
				polls: action.polls,
			};
		case 'SET_REMOVE_POSTER': {
			return {
				...state,
				isPosterRemoved: action.isPosterRemoved,
			};
		}
		case 'SET_IS_LIVE_STARTED': {
			return {
				...state,
				isLiveStarted: action.isLiveStarted,
			};
		}
		case 'SET_IS_LIVE_STOPPED': {
			return {
				...state,
				isLiveStopped: action.isLiveStopped,
			};
		}
		case 'SET_QNA_DATA':
			return {
				...state,
				qnas: action.qnas,
			};
		case 'SET_QUESTIONS_DATA':
			return {
				...state,
				questions: action.questions,
			};
		case 'ADS_PLAYING': {
			return {
				...state,
				adsPlaying: action.adsPlaying,
			};
		}
		default:
			return state;
	}
};

export default playerReducer;
